import { useMemo } from "react";
import React from "react";

import {
  PageWrap,
  Section,
  Hero,
  HeroSub,
  HeroTitle,
  CompanyDetails,
  CompanyDetailsInner,
  CompanyTitle,
  CompanyText,
} from "./ContactPageStyles";

import MapBanner from "../../components/MapBanner/MapBanner";
import ContactForm from "../../components/ContactForm/ContactForm";
import ContactInfo from "../../components/ContactInfo/ContactInfo";

export default function ContactPage() {
  const brand = "Ahava Cakes";
  const address = "Strada Elena Ghiba Birta 6-8, 310030 Arad";
  const mapsLatLng = { lat: 46.1667, lng: 21.3167 };
  const mapsUrl =
    "https://www.google.com/maps/place/Ahava+Cakes+-+Cofet%C4%83rie+Arad/@46.1803242,21.315255,17z/data=!3m1!4b1!4m6!3m5!1s0x474599150cbff7bd:0xb27805b588efb352!8m2!3d46.1803242!4d21.315255!16s%2Fg%2F11sf72cqjn?entry=ttu&g_ep=EgoyMDI2MDIyNS4wIKXMDSoASAFQAw%3D%3D";
  const phone = "+40 775 107 107";
  const email = "office@ahavacakes.ro";

  const schedule = useMemo(
    () => [
      { k: "Luni", v: "08:00 – 20:00" },
      { k: "Marți", v: "08:00 – 20:00" },
      { k: "Miercuri", v: "08:00 – 20:00" },
      { k: "Joi", v: "08:00 – 20:00" },
      { k: "Vineri", v: "08:00 – 20:00" },
      { k: "Sâmbătă", v: "08:00 – 19:00" },
      { k: "Duminică", v: "09:00 – 19:00" },
    ],
    [],
  );

  return (
    <PageWrap>
      <Hero>
        <HeroTitle>Contact</HeroTitle>
        <HeroSub>
          Scrie-ne și revenim cu drag. Pentru comenzi personalizate, menționează
          data evenimentului.
        </HeroSub>
      </Hero>

      <MapBanner center={mapsLatLng} markerTitle={brand} />

      <Section aria-label="Formular de contact Ahava Cakes">
        <ContactForm brand={brand} email={email} phone={phone} />
      </Section>

      <ContactInfo
        brand={brand}
        address={address}
        mapsUrl={mapsUrl}
        phones={[phone]}
        email={email}
        schedule={schedule}
        note="Pentru comenzi personalizate, lasă-ne un mesaj cu data evenimentului."
      />

      <CompanyDetails>
        <CompanyDetailsInner>
          <CompanyTitle>Date comerciale</CompanyTitle>
          <CompanyText>S.C. VIBE’ART MARROX SOLUTION SRL</CompanyText>
          <CompanyText>CUI: RO34829837</CompanyText>
          <CompanyText>
            Adresă sediu / punct de lucru: Str. Elena Ghiba Birta 6-8, Arad,
            Arad
          </CompanyText>
        </CompanyDetailsInner>
      </CompanyDetails>
    </PageWrap>
  );
}
